'use strict'

import { $log, $q } from '../helpers/angular-migration-helpers'

class CrcCalculator
  crcTable = null
  getCrcTable = ->
    if !crcTable
      crcTable = []
      for index in [0..255]
        val = index
        for bit in [0..7]
          val = if val & 1 then 0xedb88320 ^ (val >>> 1) else val >>> 1
        crcTable[index] = val
    crcTable

  constructor: ->
    @crc = 0

  processBytes: (buf, offset, length) ->
    crc = @crc ^ -1
    crcTable = getCrcTable()
    for index in [offset..(offset + length - 1)]
      crc = (crc >>> 8) ^ crcTable[(crc ^ buf[index]) & 0xff]
    @crc = crc ^ -1

class CRC
  getString: ->
    'crc'

  processSlice: (fileInfo, blob, chunk) ->
    # If the file is compressed or it is encrypted, then
    # these processors already take care of generating a CRC
    if fileInfo.compressionLevel || fileInfo.isEncrypted
      return blob

    # Determine the CRC
    dfd = $q.defer()

    # Load the file
    fr = new FileReader()

    # Error handlers
    fr.onabort = fr.onerror = ->
      $log.error(
        "Unable to read file '#{fileInfo.name}': #{fr.error.message} (#{
          fr.error.name
        })"
      )
      dfd.reject()

    # Success flow
    fr.onload = ->
      # Determine when we started processing
      #start = Date.now()

      # Obtain the filedata as a byte array
      fileData = new Uint8Array fr.result

      # Calculate CRC
      fileInfo.crcCalculator = new CrcCalculator() if !fileInfo.crcCalculator
      fileInfo.crcCalculator.processBytes fileData, 0, fr.result.byteLength

      # Determine if we are processing the last chunk
      if chunk == fileInfo.totalChunks - 1
        fileInfo.crc = fileInfo.crcCalculator.crc
        delete fileInfo.crcCalculator

      # Determine when we finished constructing the new blob
      #end = Date.now()
      #$log.log "#{fileInfo.name} (#{chunk+1}/#{fileInfo.totalChunks}): CRC (#{end-start}ms)"

      # Resolve the operation with the compressed blob
      dfd.resolve blob

    # Read the data
    fr.readAsArrayBuffer blob
    dfd.promise

export default CRC
